// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2qxMZ","left":"StickyBox_left__2TQEM","right":"StickyBox_right__2vvAN"};